import React from "react"
import { Box as MuiBox, BoxProps } from "@mui/material"

export type PrimitiveBoxProps = BoxProps

export const PrimitiveBox = (props: PrimitiveBoxProps) => {
	return <MuiBox {...props} />
}
